class PaginationClients {
  constructor(el) {
    this.el = el;
    this.digit = el.querySelector('.digit');

    this.bindListeners();
  }

  bindListeners() {
    this.el.addEventListener("click", this.handleClick.bind(this));
    this.paginationCount();
  }

  handleClick() {
    const hiddenItems = document.querySelectorAll(".clients__logo.hide");

    Array.from(hiddenItems).slice(0, 24).forEach(item => {
      item.classList.add("show");
      item.classList.remove("hide");
    });

    const remainingHide = Array.from(hiddenItems).some(item => item.classList.contains("hide"));

    if (!remainingHide) {
      this.el.classList.add('hide');
    }
    this.paginationCount();
  }

  paginationCount() {
    const hiddenItems = document.querySelectorAll(".clients__logo.hide");
    this.digit.innerHTML = '[+' + hiddenItems.length + ']';
  }
}

function initPaginationClients() {
  const showMorebtn = document.querySelector(".clients__pagination .btn");

  if (showMorebtn) {
    new PaginationClients(showMorebtn);
  }
}

initPaginationClients();